import { render, staticRenderFns } from "./LkModal.vue?vue&type=template&id=1b819eb0&scoped=true&"
import script from "./LkModal.vue?vue&type=script&lang=js&"
export * from "./LkModal.vue?vue&type=script&lang=js&"
import style0 from "./LkModal.vue?vue&type=style&index=0&id=1b819eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b819eb0",
  null
  
)

export default component.exports